export type Speaker = 'syqi'|'telos'|'oracle'|'numa'|'kyrs'|'krnos'|'metis'|'clio';
export interface TourLine { id: string; text: string; audio?: string }
export interface TourStep {
  id: string; stop: 0|1|2|3|4|5; speaker: Speaker; screen: 'compass'|'self'|'orb'|'tool'|'deitytool';
  lines: TourLine[]; target?: string; waitFor?: string | string[]; // ordered sequence when array
  targets?: string[]; // aligned 1:1 with an array waitFor: the live target moves as each event fires
}
